import service from '@/store/services/order-service';

const state = {
    mainPhotoBlock: {},
    historyBlock: {},
    prevOrdersBlock: {},
    prevOrdersBlockById: {},
    infoBlock: {},
    downtime: {},
    downtimeFuncBased: {},
    downtimeIdleTime: {},
    dailyChatVersionRetoucherRatings: {},
    downtimeForTestRetoucher: {},
    downloadExample: {},
    getNewOrder: {},
    setToIdleTime: {},
    submitOrder: {},
    submitComments: {},
    submitProblem: {},
    submitFile: {},
    whichRetoucher: {},
    whichRetouchersRejectedToAnotherList: {},
    downtimeInOrderStart: {},
    downtimeInOrderFinish: {},
    clearOrderInRetoucher: {},
    writeRejected: {},
    actionBlockSelects: {},
    financeBlockForRetoucher: {},
    downloadFromBackFile: {},
    orderFunctionsBlock: {},
    orderFunctionsClientFile: {},
    downtimeProRetoucher: {},
    downtimeSeniorRetoucher: {},
    countNewOrders: {},
    countNewOrdersPro: {},
    countPersonalOrders: {},
    ordersStatSenior:{},
    viewOrderId: null,
    viewOrderSignedResponse: {},
    viewOrder: {},
    addFunctionToOrder: {},
    deleteFunctionToOrder: {},
    restoreFunctionToOrder: {},
    lastRetouchers:{},
  //  checkDownloadFile:{},
    logDownloadFile:{},
    adminComments:{},
    addFaceToOrder: {},
    deleteFaceFromOrder: {},
    restoreFaceFromOrder:{}

};

const mutations = {
    SET_MAIN_PHOTO_BLOCK: (state, mainPhotoBlock) => {
        state.mainPhotoBlock = mainPhotoBlock;
    },

    SET_ACTION_BLOCK_SELECTS: (state, actionBlockSelects) => {
        state.actionBlockSelects = actionBlockSelects;
    },

    SET_HISTORY_BLOCK: (state, historyBlock) => {
        state.historyBlock = historyBlock;
    },

    SET_LAST_RETOUCHERS: (state, lastRetouchers) => {
        state.lastRetouchers = lastRetouchers;
    },

    SET_ADMIN_COMMENTS: (state, adminComments) => {
        state.adminComments = adminComments;
    },

    SET_PREV_ORDERS_BLOCK: (state, prevOrdersBlock) => {
        state.prevOrdersBlock = prevOrdersBlock;
    },

    SET_PREV_ORDERS_BLOCK_BY_ID: (state, prevOrdersBlockById) => {
        state.prevOrdersBlockById = prevOrdersBlockById;
    },

    SET_INFO_BLOCK: (state, infoBlock) => {
        state.infoBlock = infoBlock;
    },

    SET_FINANCE_BLOCK_FOR_RETOUCHER: (state, financeBlockForRetoucher) => {
        state.financeBlockForRetoucher = financeBlockForRetoucher;
    },

    SET_DOWNTIME: (state, downtime) => {
        state.downtime = downtime;
    },
    SET_DOWNTIME_FUNC_BASED: (state, downtime) => {
        state.downtimeFuncBased = downtime;
    },
    SET_DOWNTIME_IDLE_TIME: (state, downtime) => {
        state.downtimeIdleTime = downtime;
    },
    SET_DAILY_CHAT_VERSION_RETOUCHER_RATING: (state, dailyChatVersionRetoucherRatings) => {
        state.dailyChatVersionRetoucherRatings = dailyChatVersionRetoucherRatings;
    },
    SET_DOWNLOAD_EXAMPLE: (state, downloadExample) => {
        state.downloadExample = downloadExample;
    },

    SET_GET_NEW_ORDER: (state, getNewOrder) => {
        state.getNewOrder = getNewOrder;
    },

    SET_TO_IDLE_TIME: (state, setToIdleTime) => {
        state.setToIdleTime = setToIdleTime;
    },

    SET_SUBMIT_ORDER: (state, submitOrder) => {
        state.submitOrder = submitOrder;
    },

    SET_SUBMIT_COMMENTS: (state, submitComments) => {
        state.submitComments = submitComments;
    },

    SET_SUBMIT_PROBLEM: (state, submitProblem) => {
        state.submitProblem = submitProblem;
    },

    SET_SUBMIT_FILE: (state, submitFile) => {
        state.submitFile = submitFile;
    },
    SET_DOWNTIME_FOR_TEST_RETOUCHER: (state, downtimeForTestRetoucher) => {
        state.downtimeForTestRetoucher = downtimeForTestRetoucher;
    },
    SET_DOWNTIME_FOR_PRO_RETOUCHER: (state, downtimeProRetoucher) => {
        state.downtimeProRetoucher = downtimeProRetoucher;
    },
    SET_DOWNTIME_FOR_SENIOR_RETOUCHER: (state, downtimeSeniorRetoucher) => {
        state.downtimeSeniorRetoucher = downtimeSeniorRetoucher;
    },

    SET_WHICH_RETOUCHER: (state, whichRetoucher) => {
        state.whichRetoucher = whichRetoucher;
    },

    SET_WHICH_RETOUCHERS_REJECTED_TO_ANOTHER_LIST: (state, whichRetouchersRejectedToAnotherList) => {
        state.whichRetouchersRejectedToAnotherList = whichRetouchersRejectedToAnotherList;
    },

    SET_WRITE_REJECTED: (state, writeRejected) => {
        state.writeRejected = writeRejected;
    },

    SET_DOWNTIME_IN_ORDER_START: (state, submitFile) => {
        state.downtimeInOrderStart = submitFile;
    },

    SET_DOWNTIME_IN_ORDER_FINISH: (state, submitFile) => {
        state.downtimeInOrderFinish = submitFile;
    },

    SET_CLEAR_ORDER_IN_RETOUCHER: (state, submitFile) => {
        state.clearOrderInRetoucher = submitFile;
    },

    SET_DOWNLOAD_VERSION_OF_PHOTO: (state, downloadFromBackFile) => {
        state.downloadFromBackFile = downloadFromBackFile;
    },

    SET_ORDER_FUNCTIONS_BLOCK: (state, orderFunctionsBlock) => {
        state.orderFunctionsBlock = orderFunctionsBlock;
    },

    SET_ORDER_FUNCTIONS_CLIENT_FILE: (state, orderFunctionsClientFile) => {
        state.orderFunctionsClientFile = orderFunctionsClientFile;
    },

    SET_COUNT_NEW_ORDERS: (state, countNewOrders) => {
        state.countNewOrders = countNewOrders;
    },
    SET_COUNT_NEW_ORDERS_PRO: (state, countNewOrdersPro) => {
        state.countNewOrdersPro = countNewOrdersPro;
    },
    SET_COUNT_PERSONAL_ORDERS: (state, countPersonalOrders) => {
        state.countPersonalOrders = countPersonalOrders;
    },
    SET_ORDERS_STAT_SENIOR: (state, ordersStatSenior) => {
        state.ordersStatSenior = ordersStatSenior;
    },
    SET_VIEW_ORDER_ID: (state, viewOrderId) => {
        state.viewOrderId = viewOrderId;
    },
    SET_VIEW_ORDER_SIGNED: (state, viewOrderSignedResponse) => {
        state.viewOrderSignedResponse = viewOrderSignedResponse;
    },
    SET_VIEW_ORDER: (state, viewOrder) => {
        state.viewOrder = viewOrder;
    },
    SET_ADD_FUNCTION_TO_ORDER: (state, functions) => {
        state.addFunctionToOrder = functions;
    },
    SET_DELETE_FUNCTION_TO_ORDER: (state, functions) => {
        state.deleteFunctionToOrder = functions;
    },
    SET_RESTORE_FUNCTION_TO_ORDER: (state, functions) => {
        state.restoreFunctionToOrder = functions;
    },
    SET_ADD_FACE_TO_ORDER: (state, functions) => {
        state.addFaceToOrder = functions;
    },
    SET_DELETE_FACE_FROM_ORDER: (state, functions) => {
        state.deleteFaceFromOrder = functions;
    },
    SET_RESTORE_FACE_FROM_ORDER: (state, functions) => {
        state.restoreFaceFromOrder = functions;
    },
    // SET_CHECK_DOWNLOAD_FILE: (state, functions) => {
    //     state.checkDownloadFile = functions;
    // },
    SET_LOG_DOWNLOAD_FILE: (state, functions) => {
        state.logDownloadFile = functions;
    },
};

const actions = {
    getActionBlockSelects({commit}) {
        return service.getActionBlockSelects()
            .then(({actionBlockSelects}) => {
                commit('SET_ACTION_BLOCK_SELECTS', actionBlockSelects);
            });
    },

    mainPhotoBlock({commit, dispatch}, params) {
        return service.mainPhotoBlock(params)
            .then(({mainPhotoBlock}) => {
                commit('SET_MAIN_PHOTO_BLOCK', mainPhotoBlock);
            });
    },
    mainPhotoBlockForRetoucher({commit, dispatch}, params) {
        return service.mainPhotoBlockForRetoucher(params)
            .then(({mainPhotoBlock}) => {
                commit('SET_MAIN_PHOTO_BLOCK', mainPhotoBlock);
            });
    },
    historyBlock({commit, dispatch}, payload) {

        let order_id, archive;

        if (typeof payload === 'object') {
            ({order_id, archive = false} = payload);
        } else {
            order_id = payload;
            archive = false;
        }
        return service.historyBlock(order_id, archive)
            .then(({historyBlock}) => {
                commit('SET_HISTORY_BLOCK', historyBlock);
            });
    },
    lastRetouchers({commit, dispatch}, params) {
        return service.lastRetouchers(params)
            .then(({lastRetouchers}) => {
                commit('SET_LAST_RETOUCHERS', lastRetouchers);
            });
    },
    adminComments({commit, dispatch}, params) {
        return service.adminComments(params)
            .then(({adminComments}) => {
                commit('SET_ADMIN_COMMENTS', adminComments);
            });
    },
    countNewOrders({commit, dispatch}, params) {
        return service.countNewOrders(params)
            .then(({countNewOrders}) => {
                commit('SET_COUNT_NEW_ORDERS', countNewOrders);
            });
    },
    countNewOrdersPro({commit, dispatch}, params) {
        return service.countNewOrdersPro(params)
            .then(({countNewOrdersPro}) => {
                commit('SET_COUNT_NEW_ORDERS_PRO', countNewOrdersPro);
            });
    },
    countPersonalOrders({commit, dispatch}, params) {
        return service.countPersonalOrders(params)
            .then(({countPersonalOrders}) => {
                commit('SET_COUNT_PERSONAL_ORDERS', countPersonalOrders);
            });
    },
    ordersStatSenior({commit, dispatch}, params) {
        return service.ordersStatSenior(params)
            .then(({ordersStatSenior}) => {
                commit('SET_ORDERS_STAT_SENIOR', ordersStatSenior);
            });
    },
    prevOrdersBlock({commit, dispatch}, params) {
        return service.prevOrdersBlock(params)
            .then(({prevOrdersBlock}) => {
                commit('SET_PREV_ORDERS_BLOCK', prevOrdersBlock);
            });
    },
    prevOrdersBlockById({commit, dispatch}, { order_id, archive }) {
        return service.prevOrdersBlockById(order_id, archive)
            .then(({prevOrdersBlockById}) => {
                commit('SET_PREV_ORDERS_BLOCK_BY_ID', prevOrdersBlockById);
            });
    },
    downloadFromBackFile({commit, dispatch}, params) {
        return service.downloadFromBackFile(params)
            .then(({downloadFromBackFile}) => {
                commit('SET_DOWNLOAD_VERSION_OF_PHOTO', downloadFromBackFile);
            });
    },

    infoBlock({commit, dispatch}, params) {
        return service.infoBlock(params)
            .then(({infoBlock}) => {
                commit('SET_INFO_BLOCK', infoBlock);
            });
    },

    financeBlockForRetoucher({commit, dispatch}, payload) {
        return service.financeBlockForRetoucher(payload)
            .then(({financeBlockForRetoucher}) => {
                commit('SET_FINANCE_BLOCK_FOR_RETOUCHER', financeBlockForRetoucher);
            });
    },

    downtimeRetoucher({commit}, payload) {
        return service.downtimeRetoucher(payload)
            .then(({downtime}) => {
                commit('SET_DOWNTIME', downtime);
            });
    },

    downtimeRetoucherFuncBased({commit}, payload) {
        return service.downtimeRetoucherFuncBased(payload)
            .then(({downtime}) => {
                commit('SET_DOWNTIME_FUNC_BASED', downtime);
            });
    },
    downtimeRetoucherIdleTime({commit}, payload) {
        return service.downtimeRetoucherIdleTime(payload)
            .then(({downtime}) => {
                commit('SET_DOWNTIME_IDLE_TIME', downtime);
            });
    },

    downtime({commit, dispatch}, params) {
        return service.downtime(params)
            .then(({downtime}) => {
                commit('SET_DOWNTIME', downtime);
            });
    },

    downtimeFuncBased({commit, dispatch}, params) {
        return service.downtimeFuncBased(params)
            .then(({downtime}) => {
                commit('SET_DOWNTIME_FUNC_BASED', downtime);
            });
    },
    downtimeIdleTime({commit, dispatch}, params) {
        return service.downtimeIdleTime(params)
            .then(({downtime}) => {
                commit('SET_DOWNTIME_IDLE_TIME', downtime);
            });
    },

    dailyChatVersionRetoucherRatings({commit, dispatch}, params) {
        return service.dailyChatVersionRetoucherRatings(params)
            .then(({dailyChatVersionRetoucherRatings}) => {
                commit('SET_DAILY_CHAT_VERSION_RETOUCHER_RATING', dailyChatVersionRetoucherRatings);
            });
    },

    downtimeForTestRetoucher({commit, dispatch}, params) {
        return service.downtimeForTestRetoucher(params)
            .then(({downtimeForTestRetoucher}) => {
                commit('SET_DOWNTIME_FOR_TEST_RETOUCHER', downtimeForTestRetoucher);
            });
    },

    downtimeProRetoucher({commit, dispatch}, params) {
        return service.downtimeProRetoucher(params)
            .then(({downtimeProRetoucher}) => {
                commit('SET_DOWNTIME_FOR_PRO_RETOUCHER', downtimeProRetoucher);
            });
    },

    downtimeSeniorRetoucher({commit, dispatch}, params) {
        return service.downtimeSeniorRetoucher(params)
            .then(({downtimeSeniorRetoucher}) => {
                commit('SET_DOWNTIME_FOR_SENIOR_RETOUCHER', downtimeSeniorRetoucher);
            });
    },

    orderFunctionsBlock({commit, dispatch}, params) {
        return service.orderFunctionsBlock(params)
            .then(({orderFunctionsBlock}) => {
                commit('SET_ORDER_FUNCTIONS_BLOCK', orderFunctionsBlock);
            });
    },
    orderFunctionsClientFile({commit, dispatch}, params) {
        return service.orderFunctionsClientFile(params)
            .then(({orderFunctionsClientFile}) => {
                commit('SET_ORDER_FUNCTIONS_CLIENT_FILE', orderFunctionsClientFile);
            });
    },
    downloadExample({commit, dispatch}, params) {
        return service.downloadExample(params)
            .then(({downloadExample}) => {
                commit('SET_DOWNLOAD_EXAMPLE', downloadExample);
            });
    },
    getNewOrder({commit, dispatch}, params) {
        return service.getNewOrder(params)
            .then(({getNewOrder}) => {
                commit('SET_GET_NEW_ORDER', getNewOrder);
            });
    },
    setToIdleTime({commit, dispatch}, params) {
        return service.setToIdleTime(params)
            .then(({setToIdleTime}) => {
                commit('SET_TO_IDLE_TIME', setToIdleTime);
            });
    },
    submitOrder({commit, dispatch}, params) {
        return service.submitOrder(params)
            .then(({submitOrder}) => {
                commit('SET_SUBMIT_ORDER', submitOrder);
            });
    },
    submitComments({commit, dispatch}, params) {
        return service.submitComments(params)
            .then(({submitComments}) => {
                commit('SET_SUBMIT_COMMENTS', submitComments);
            });
    },

    submitProblem({commit, dispatch}, params) {
        return service.submitProblem(params)
            .then(({submitProblem}) => {
                commit('SET_SUBMIT_PROBLEM', submitProblem);
            });
    },

    submitFile({commit, dispatch}, params) {
        return service.submitFile(params)
            .then(({submitFile}) => {
                commit('SET_SUBMIT_FILE', submitFile);
            });
    },

    whichRetoucher({commit, dispatch}, params) {
        return service.whichRetoucher(params)
            .then(({whichRetoucher}) => {
                commit('SET_WHICH_RETOUCHER', whichRetoucher);
            });
    },

    whichRetouchersRejectedToAnotherList({commit, dispatch}, params) {
        return service.whichRetouchersRejectedToAnotherList(params)
            .then(({whichRetouchersRejectedToAnotherList}) => {
                commit('SET_WHICH_RETOUCHERS_REJECTED_TO_ANOTHER_LIST', whichRetouchersRejectedToAnotherList);
            });
    },

    writeRejected({commit, dispatch}, params) {
        return service.writeRejected(params)
            .then(({writeRejected}) => {
                commit('SET_WRITE_REJECTED', writeRejected);
            });
    },
    setViewOrderId({commit, dispatch}, params) {
        return service.setViewOrder(params)
            .then(({viewOrder}) => {
                commit('SET_VIEW_ORDER_ID', params);
            });
    },
    setViewOrderSignedNumber({commit, dispatch}, params) {
        return service.setViewOrderSigned(params)
            .then((result) => {
                commit('SET_VIEW_ORDER_ID', null);
                if (undefined !== result) {
                    commit('SET_VIEW_ORDER_ID', result.order);
                }
                commit('SET_VIEW_ORDER_SIGNED', result);
            });
    },

    getViewOrder({commit, dispatch}, payload) {

        let order_id, archive;

        if (typeof payload === 'object') {
            ({order_id, archive = false} = payload);
        } else {
            order_id = payload;
            archive = false;
        }
        return service.getViewOrder(order_id, archive)
            .then(({viewOrder}) => {
                commit('SET_VIEW_ORDER', viewOrder);
            });
    },
    addFunctionToOrder({commit, dispatch}, params) {
        return service.addFunctionToOrder(params).then(({functions}) => {
            commit('SET_ADD_FUNCTION_TO_ORDER', functions);
        });
    },
    deleteFunctionToOrder({commit, dispatch}, params) {
        return service.deleteFunctionToOrder(params).then(({functions}) => {
            commit('SET_DELETE_FUNCTION_TO_ORDER', functions);
        });
    },
    restoreFunctionToOrder({commit, dispatch}, params) {
        return service.restoreFunctionToOrder(params).then(({functions}) => {
            commit('SET_RESTORE_FUNCTION_TO_ORDER', functions);
        });
    },
    addFaceToOrder({commit}, params) {
        return service.addFaceToOrder(params).then(({functions}) => {
            commit('SET_ADD_FACE_TO_ORDER', functions);
        });
    },
    deleteFaceFromOrder({commit}, params) {
        return service.deleteFaceFromOrder(params).then(({functions}) => {
            commit('SET_DELETE_FACE_FROM_ORDER', functions);
        });
    },
    restoreFaceFromOrder({commit}, params) {
        return service.restoreFaceFromOrder(params).then(({functions}) => {
            commit('SET_RESTORE_FACE_FROM_ORDER', functions);
        });
    },
    // checkDownloadFile({commit, dispatch}, params) {
    //     return service.checkDownloadFile(params)
    //         .then(({checkDownloadFile}) => {
    //             commit('SET_CHECK_DOWNLOAD_FILE', checkDownloadFile);
    //         });
    // },
    logDownloadFile({commit, dispatch}, params) {
        return service.logDownloadFile(params)
            .then(({logDownloadFile}) => {
                commit('SET_LOG_DOWNLOAD_FILE', logDownloadFile);
            });
    },
};

const getters = {
    mainPhotoBlock: state => state.mainPhotoBlock,
    historyBlock: state => state.historyBlock,
    prevOrdersBlock: state => state.prevOrdersBlock,
    prevOrdersBlockById: state => state.prevOrdersBlockById,
    infoBlock: state => state.infoBlock,
    downtime: state => state.downtime,
    downtimeFuncBased: state => state.downtimeFuncBased,
    downtimeIdleTime: state => state.downtimeIdleTime,
    dailyChatVersionRetoucherRatings: state => getterKey => state.dailyChatVersionRetoucherRatings,
    downloadExample: state => getterKey => state.downloadExample,
    getNewOrder: state => state.getNewOrder,
    setToIdleTime: state => state.setToIdleTime,
    submitOrder: state => state.submitOrder,
    submitComments: state => state.submitComments,
    submitProblem: state => state.submitProblem,
    submitFile: state => state.submitFile,
    whichRetoucher: state => state.whichRetoucher,
    whichRetouchersRejectedToAnotherList: state => state.whichRetouchersRejectedToAnotherList,
    writeRejected: state => state.writeRejected,
    downtimeForTestRetoucher: state => state.downtimeForTestRetoucher,
    getActionBlockSelects: state => state.actionBlockSelects,
    downloadFromBackFile: state => state.downloadFromBackFile,
    orderFunctionsBlock: state => state.orderFunctionsBlock,
    orderFunctionsClientFile: state => state.orderFunctionsClientFile,
    financeBlockForRetoucher: state => state.financeBlockForRetoucher,
    downtimeProRetoucher: state => state.downtimeProRetoucher,
    downtimeSeniorRetoucher: state => state.downtimeSeniorRetoucher,
    countNewOrders: state => state.countNewOrders,
    countNewOrdersPro: state => state.countNewOrdersPro,
    countPersonalOrders: state => state.countPersonalOrders,
    ordersStatSenior: state => state.ordersStatSenior,
    viewOrderId: state => state.viewOrderId,
    viewOrderSignedNumber: state => state.viewOrderSignedResponse,
    viewOrder: state => state.viewOrder,
    addFunctionToOrder: state => state.addFunctionToOrder,
    deleteFunctionToOrder: state => state.deleteFunctionToOrder,
    restoreFunctionToOrder: state => state.restoreFunctionToOrder,
    lastRetouchers: state => state.lastRetouchers,
    adminComments: state => state.adminComments,
   // checkDownloadFile: state =>state.checkDownloadFile,
    logDownloadFile: state =>state.logDownloadFile,
    addFaceToOrder: state => state.addFaceToOrder,
    deleteFaceFromOrder: state => state.deleteFaceFromOrder,
    restoreFaceFromOrder: state => state.restoreFaceFromOrder,

};

const order = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default order;